@if (shouldShowModal()) {
  <div class="v-one-company-selector-modal-overlay"></div>

  <div
    class="v-one-company-selector-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
  >
    <div class="v-one-company-selector-modal__content">
      <div class="v-one-company-selector-modal__header">
        <div class="v-one-company-selector-modal__header-badge">
          <div class="v-one-company-selector-modal__header-logo">
            <img
              src="assets/uplift/img/brand/v-one-insight-isotype.svg"
              alt="V-One"
              class="v-one-company-selector-modal__header-logo-image"
            />
          </div>
          <h2 id="modal-title" class="v-one-company-selector-modal__title">
            {{ 'global.company.selection' | translate }}
          </h2>
        </div>
      </div>

      <ng-container [ngTemplateOutlet]="companyList"></ng-container>
    </div>
  </div>
}

@if (!shouldShowModal()) {
  <div
    class="v-one-company-selector"
    [class.v-one-company-selector--open]="isDropdownOpen()"
    (click)="$event.stopPropagation()"
    (keydown)="onContainerKeydown($event)"
    tabindex="0"
    role="combobox"
    [attr.aria-expanded]="isDropdownOpen()"
    aria-controls="company-dropdown-list"
  >
    <button
      class="v-one-company-selector__company-button"
      [class.v-one-company-selector__company-button--open]="isDropdownOpen()"
      (click)="toggleDropdown()"
      [attr.aria-expanded]="isDropdownOpen()"
      aria-label="Select company"
    >
      <div class="v-one-company-selector__company-logo">
        @if (selectedCompany()?.logo) {
          <img
            [src]="selectedCompany()!.logo"
            [alt]="selectedCompany()!.name"
            class="v-one-company-selector__company-logo-image"
            onerror="
              this.src =
                'assets/uplift/img/brand/v-one-insight-isologo_default.svg'
            "
          />
        } @else {
          <div class="v-one-company-selector__company-logo-placeholder">
            {{ selectedCompany()?.name?.charAt(0)?.toUpperCase() }}
          </div>
        }
      </div>

      <span class="v-one-company-selector__company-name">
        {{ capitalizeNameCompany(selectedCompany()?.name) }}
      </span>

      <v-one-icon
        name="chevronDown"
        [type]="ICON_TYPE.OUTLINE"
        class="v-one-company-selector__chevron"
        [class.v-one-company-selector__chevron--rotated]="isDropdownOpen()"
      >
      </v-one-icon>
    </button>

    @if (isDropdownOpen()) {
      <ng-container [ngTemplateOutlet]="companyList"></ng-container>
    }
  </div>
}

<ng-template #companyList>
  <ul
    [id]="shouldShowModal() ? undefined : 'company-dropdown-list'"
    [class]="
      shouldShowModal()
        ? 'v-one-company-selector-modal__list'
        : 'v-one-company-selector__company-menu'
    "
    role="listbox"
  >
    @for (company of companies(); track company.id) {
      <li
        [class]="
          shouldShowModal()
            ? 'v-one-company-selector-modal__option'
            : 'v-one-company-selector__company-option'
        "
        [class.v-one-company-selector__company-option--selected]="
          !shouldShowModal() && company.isSelected
        "
        [attr.role]="'option'"
        [attr.tabindex]="0"
        [attr.aria-selected]="company.isSelected"
        (click)="selectCompany(company)"
        (keydown.enter)="selectCompany(company)"
        (keydown.space)="selectCompany(company)"
        (mousedown)="!shouldShowModal() ? '$event.preventDefault()' : null"
      >
        <div
          [class]="
            shouldShowModal()
              ? 'v-one-company-selector-modal__option-logo'
              : 'v-one-company-selector__company-option-logo'
          "
          [class.v-one-company-selector-modal__option-logo--no-bg]="
            shouldShowModal() && company.logo
          "
        >
          @if (company.logo) {
            <img
              [src]="company.logo"
              [alt]="company.name"
              [class]="
                shouldShowModal()
                  ? 'v-one-company-selector-modal__option-logo-image'
                  : 'v-one-company-selector__company-option-logo-image'
              "
              onerror="
                this.src =
                  'assets/uplift/img/brand/v-one-insight-isologo_default.svg'
              "
            />
          } @else {
            <div
              [class]="
                shouldShowModal()
                  ? 'v-one-company-selector-modal__option-logo-placeholder'
                  : 'v-one-company-selector__company-option-logo-placeholder'
              "
            >
              {{ company.name.charAt(0).toUpperCase() }}
            </div>
          }
        </div>

        <span
          [class]="
            shouldShowModal()
              ? 'v-one-company-selector-modal__option-name'
              : 'v-one-company-selector__company-option-name'
          "
        >
          {{ company.name }}
        </span>
      </li>
    }
  </ul>
</ng-template>
